import Vue from 'vue';
import VueGtag from 'vue-gtag';
// import AddToHomeScreen from './a2hs';
// import CartFrame from './CartFrame.vue';
import AccessoryItem from './AccessoryItem.vue';
import ThicknessButtons from './ThicknessButtons.vue';
import './registerServiceWorker';

Vue.config.productionTip = false;

// Vue.component('cart-frame', CartFrame);
Vue.component('accessory-item', AccessoryItem);
Vue.component('thickness-buttons', ThicknessButtons);

Vue.use(VueGtag, {
  config: { id: 'UA-20677020-1' },
  params: {
    send_page_view: true, // Page views aren't firing automatically so is being called manually in mounted()
  },
});

const screwData = {
  timber: {
    50: {
      screwTypeString: '50mm SPAX decking',
      largeScrewProductId: 355,
      screwProductId: 50,
      boxQuantity: 200,
      largeBoxQuantity: 600,
    },
    60: {
      screwTypeString: '60mm SPAX decking',
      largeScrewProductId: 356,
      screwProductId: 60,
      boxQuantity: 100,
      largeBoxQuantity: 600,
    },
    70: {
      screwTypeString: '70mm SPAX decking',
      screwProductId: 59,
      boxQuantity: 100,
    },
    80: {
      screwTypeString: '80mm SPAX decking',
      screwProductId: 61,
      boxQuantity: 100,
    },
    100: {
      screwTypeString: '100mm SPAX decking',
      screwProductId: 286,
      boxQuantity: 100,
    },
    accessories: {
      essential: [
        {
          name: 'T-25 drive bits',
          productId: 58,
          imgSrc: 'img/BIT_T25.png',
          boxQuantity: 5,
          quantity: (screws, resultInBox) => {
            // if (!resultInBox.addOrderQuantity) {
            //   return 5;
            // }
            // if (resultInBox.addOrderQuantity < 2 && resultInBox.orderQuantity >= 1) {
            //   return 5;
            // }
            // return 0;
            return 5;
          },
        },
        {
          name: 'SPAX Step Drill 4',
          productId: 90,
          imgSrc: 'img/Step_drill_4.png',
          boxQuantity: 1,
          quantity: (screws, resultInBox) => {
            // if (!resultInBox.addOrderQuantity) {
            return 1;
            // }
            // return 0;
          },
        },
        {
          name: 'Step Drill 4 replacement bit',
          productId: 182,
          imgSrc: 'img/drill4-replace.png',
          boxQuantity: 1,
          quantity: (screws, resultInBox, thick) => {
            // if (!resultInBox.addOrderQuantity) {
              if (thick === '12-19' || thick === '19' || thick === '19-24') {
                return Math.ceil(screws / 1500);
              }
            // }
            return 0;
          },
        },
        {
          name: 'Step Drill 4 replacement bit 150mm',
          productId: 351,
          imgSrc: 'img/drill4-replace.png',
          boxQuantity: 1,
          quantity: (screws, resultInBox, thick) => {
            // if (!resultInBox.addOrderQuantity) {
              if (thick === '24-28' || thick === '28-32' || thick === '32+') {
                const answer = Math.ceil(screws / 1500);
                return answer < 2 ? 2 : answer;
              }
              return 0;
            // }
            // return 0;
          },
        },
      ],
      optional: [
        {
          name: 'SPAX Step Drill 4',
          productId: 90,
          imgSrc: 'img/Step_drill_4.png',
          boxQuantity: 1,
          quantity: (screws, resultInBox) => {
            // if (resultInBox.addOrderQuantity >= 1) {
            //  return 1;
            // }
            return 0;
          },
        },
        {
          name: 'Step Drill 4 replacement bit',
          productId: 182,
          imgSrc: 'img/drill4-replace.png',
          boxQuantity: 1,
          quantity: (screws, resultInBox) => {
            // if (resultInBox.addOrderQuantity >= 1) {
            //  return Math.ceil(screws / 1500);
            // }
            return 0;
          },
        },
        {
          name: 'Deck Spacers',
          productId: 89,
          imgSrc: 'img/deck-spacer.png',
          boxQuantity: 12,
          quantity: (screws, resultInBox) => {
            // if (resultInBox.addOrderQuantity <= 1 || !resultInBox.addOrderQuantity) {
              return 12;
            // }
            // return 0;
          },
        },
        {
          name: '50mm T-25 drive bits',
          productId: 209,
          imgSrc: 'img/bit_50mm_t25.png',
          boxQuantity: 5,
          quantity: () => 5,
        },
      ],
    },
  },
  steel: {
    44: {
      screwTypeString: '44mm SPAX timber to steel',
      screwProductId: 303,
      boxQuantity: 500,
    },
    71: {
      screwTypeString: '71mm SPAX timber to steel',
      screwProductId: 350,
      boxQuantity: 350,
    },
    accessories: {
      essential: [
        {
          name: 'T-25 drive bits',
          productId: 58,
          imgSrc: 'img/BIT_T25.png',
          boxQuantity: 5,
          quantity: () => 5,
        },
        {
          name: 'SPAX Air',
          productId: 205,
          boxQuantity: 100,
          imgSrc: 'img/air_4_5mm_6573.png',
          quantity: (screws) => Math.ceil(screws / 2),
        },
        {
          name: 'SPAX Step Drill 5',
          productId: 306,
          imgSrc: 'img/step-drill-5.png',
          boxQuantity: 1,
          quantity: (screws) => Math.ceil(screws / 1500),
        },
      ],
      optional: [
        {
          name: 'Deck Spacers',
          productId: 89,
          imgSrc: 'img/deck-spacer.png',
          boxQuantity: 12,
          quantity: () => 12,
        },
        {
          name: '50mm T-25 drive bits',
          productId: 209,
          imgSrc: 'img/bit_50mm_t25.png',
          boxQuantity: 5,
          quantity: () => 5,
        },
      ],
    },
  },
  aluminium: {
    44: {
      screwTypeString: '44mm SPAX timber to aluminium',
      screwProductId: 344,
      boxQuantity: 100,
    },
    48: {
      screwTypeString: '48mm SPAX timber to aluminium',
      screwProductId: 345,
      boxQuantity: 100,
    },
    accessories: {
      essential: [
        {
          name: 'T-25 drive bits',
          productId: 58,
          imgSrc: 'img/BIT_T25.png',
          boxQuantity: 5,
          quantity: () => 5,
        },
        {
          name: 'SPAX Air',
          productId: 205,
          boxQuantity: 100,
          imgSrc: 'img/air_4_5mm_6573.png',
          quantity: (screws) => Math.ceil(screws / 2),
        },
        {
          name: 'SPAX Step Drill 5',
          productId: 306,
          imgSrc: 'img/step-drill-5.png',
          boxQuantity: 1,
          quantity: (screws) => Math.ceil(screws / 1500),
        },
      ],
      optional: [
        {
          name: 'Deck Spacers',
          productId: 89,
          imgSrc: 'img/deck-spacer.png',
          boxQuantity: 12,
          quantity: () => 12,
        },
        {
          name: '50mm T-25 drive bits',
          productId: 209,
          imgSrc: 'img/bit_50mm_t25.png',
          boxQuantity: 5,
          quantity: () => 5,
        },
      ],
    },
  },
};

const vm = new Vue({
  el: '#app',
  filters: {
    toLocaleString(input) {
      if (input) {
        return input.toLocaleString(
          undefined,
        );
      }
      return input;
    },
  },
  data: {
    length: '',
    width: '',
    board: 90,
    joists: 450,
    manualGap: '',
    screwsPer: 2,
    thick: '19',
    joistMaterial: 'softwood',
    showCart: false,
    accessories: {},
    previousMaterial: '',
  },
  computed: {
    result() {
      try {
        let result = ((this.length / this.joists) + 1) * (this.width / (this.board + this.gap)) * this.screwsPer;
        result *= 1.1;
        return Math.ceil(result) || 0;
      } catch (error) {
        return 0;
      }
    },
    gap: {
      get: function () {
        if (this.manualGap === '') {
          return Math.round(this.board * 0.05);
        }
        return this.manualGap;
      },
      set: function (newValue) {
        this.manualGap = newValue;
      },
    },
    resultInBox() {
      // Work out quantity of screw boxes and total screws when in boxed quantity
      if (this.result && this.screwType) {
        let orderQuantity; // Number of small boxes
        let addOrderQuantity; // Number of large boxes
        const resultInBox = {};
        if (this.screwType.largeBoxQuantity) {
          addOrderQuantity = parseInt(this.result / this.screwType.largeBoxQuantity, 10);
          orderQuantity = Math.ceil((this.result - addOrderQuantity * this.screwType.largeBoxQuantity) / this.screwType.boxQuantity);
          resultInBox.totalScrews = addOrderQuantity * this.screwType.largeBoxQuantity;
          resultInBox.orderQuantity = orderQuantity;
          resultInBox.addOrderQuantity = addOrderQuantity;
          // If screws is less than large box quantity but small box quantity total is same as large box quantity, then sell the large box
          if (orderQuantity * this.screwType.boxQuantity >= this.screwType.largeBoxQuantity) {
            resultInBox.totalScrews += this.screwType.largeBoxQuantity;
            addOrderQuantity += 1;
            orderQuantity = Math.ceil((resultInBox.totalScrews - addOrderQuantity * this.screwType.largeBoxQuantity) / this.screwType.boxQuantity);
            resultInBox.orderQuantity = orderQuantity;
            resultInBox.addOrderQuantity = addOrderQuantity;
          } else {
            resultInBox.totalScrews += orderQuantity * this.screwType.boxQuantity;
          }
        } else {
          orderQuantity = Math.ceil(this.result / this.screwType.boxQuantity);
          resultInBox.totalScrews = orderQuantity * this.screwType.boxQuantity;
          resultInBox.orderQuantity = orderQuantity;
        }
        return resultInBox;
      }
      return {
        orderQuantity: 0,
        addOrderQuantity: 0,
      };
    },
    screwType() {
      let screwObject = {};
      if (this.joistMaterial === 'softwood' || this.joistMaterial === 'hardwood') {
        this.accessories = screwData.timber.accessories;
        switch (this.thick) {
          case '12':
            screwObject = screwData.timber[40];
            break;
          case '12-19':
            screwObject = screwData.timber[50];
            break;
          case '19':
            if (this.joistMaterial === 'softwood') {
              screwObject = screwData.timber[60];
            } else if (this.joistMaterial === 'hardwood') {
              screwObject = screwData.timber[50];
            }
            break;
          case '19-24':
            screwObject = screwData.timber[60];
            break;
          case '24-28':
            screwObject = screwData.timber[70];
            break;
          case '28-32':
            screwObject = screwData.timber[80];
            break;
          case '32+':
            screwObject = screwData.timber[100];
            break;
          default:
        }
      } else if (this.joistMaterial === 'steel') {
        this.accessories = screwData.steel.accessories;
        switch (this.thick) {
          case '16-22':
            screwObject = screwData.steel[44];
            break;
          case '35-50':
            screwObject = screwData.steel[71];
            break;
          default:
        }
      } else if (this.joistMaterial === 'aluminium') {
        this.accessories = screwData.aluminium.accessories;
        switch (this.thick) {
          case '16-20':
            screwObject = screwData.aluminium[44];
            break;
          case '20-24':
            screwObject = screwData.aluminium[48];
            break;
          default:
        }
      }
      return screwObject;
    },
    imgPath() {
      let imgPath;
      if (this.joistMaterial === 'softwood' || this.joistMaterial === 'hardwood') {
        imgPath = 'img/SPAX-decking-screw.png';
      } else if (this.screwType.screwProductId === 350) {
        imgPath = 'img/screw-metal-joist-long.png';
      } else {
        imgPath = 'img/screw-metal-joist.png';
      }
      return imgPath;
    },
    instructionPath() {
      if (this.joistMaterial === 'steel') {
        return 'https://screwsandfasteners.com.au/docs/SPAX-Timber-To-Steel_Brochure.pdf';
      } else if (this.joistMaterial === 'aluminium') {
        return 'https://screwsandfasteners.com.au/docs/SPAX-Timber-To-Aluminium_Brochure.pdf';
      }
      return '';
    },
  },
  mounted() {
    this.$gtag.pageview('/screw-calculator/');
    // AddToHomeScreen({
    //   brandName: 'Screw Calculator',
    // });
  },
  methods: {
    addToCart(all) {
      const shoppingCart = [];
      if (this.resultInBox.addOrderQuantity) {
        shoppingCart.push([this.screwType.largeScrewProductId, this.resultInBox.addOrderQuantity]);
      }
      shoppingCart.push([this.screwType.screwProductId, this.resultInBox.orderQuantity]);
      for (const acces of this.accessories.essential) {
        const quantity = acces.quantity(this.result, this.resultInBox, this.thick);
        let noOfBoxes;
        if (quantity) {
          noOfBoxes = Math.ceil(quantity / acces.boxQuantity);
        }
        shoppingCart.push([acces.productId, noOfBoxes]);
      }
      if (all === 1) {
        for (const acces of this.accessories.optional) {
          const quantity = acces.quantity(this.result, this.resultInBox);
          if (quantity) {
            const noOfBoxes = Math.ceil(quantity / acces.boxQuantity);
            shoppingCart.push([acces.productId, noOfBoxes]);
          }
        }
      }
      const allRequests = [];
      shoppingCart.forEach((item) => {
        const formData = new FormData();
        formData.append('product_id', item[0]);
        formData.append('quantity', item[1]);
        allRequests.push(fetch('https://screwsandfasteners.com.au/index.php?route=checkout/cart/add', {
          method: 'POST',
          body: formData,
        }));
      });
      if (typeof Promise.allSettled !== 'undefined') {
        Promise.allSettled(allRequests).then(() => {
          this.showCart = true;
          window.scrollTo(0, 0);
        });
      } else {
        setTimeout(() => {
          this.showCart = true;
          window.scrollTo(0, 0);
        }, 3000);
      }
      const label = all === 1 ? 'optional' : 'essentials';
      this.$gtag.event('add_to_cart', {
        event_category: 'ecommerce',
        event_label: label,
      });
    },
    setDefaultThickness() {
      // Don't change selected thickness when switching between hardwood & softwood
      switch (this.joistMaterial) {
        case 'softwood':
          if (this.previousMaterial === 'hardwood') {
            break;
          }
          this.thick = '19';
          break;
        case 'hardwood':
          if (this.previousMaterial === 'softwood') {
            break;
          }
          this.thick = '19';
          break;
        case 'steel':
          this.thick = '16-22';
          break;
        case 'aluminium':
          this.thick = '16-20';
          break;
        default:
          break;
      }
    },
  },
});
